import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

export function useUser() {
    return computed(() => usePage().props.auth.user);
}
